/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobStatistics {
    getFixupPrototypeFunction() { return BackgroundJobStatistics.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobStatistics>): BackgroundJobStatistics {
        let obj = Object.assign(new BackgroundJobStatistics(), model);
        BackgroundJobStatistics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobStatistics>): BackgroundJobStatistics {
        if (!model) return null;
        return BackgroundJobStatistics.newInstance(<BackgroundJobStatistics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobStatistics) {
        if (!obj) return;

        models.BackgroundJobStatistics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobStatistics): boolean {
        Object.setPrototypeOf(obj, BackgroundJobStatistics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.executing_jobs === undefined) {
            this.executing_jobs = 0;
        }
        if (this.processed_jobs === undefined) {
            this.processed_jobs = 0;
        }
        if (this.restarted_jobs === undefined) {
            this.restarted_jobs = 0;
        }
        if (this.failed_jobs === undefined) {
            this.failed_jobs = 0;
        }
        if (this.query_counters_per_caller) {
            for (let val of this.query_counters_per_caller) {
                models.BackgroundJobQueryCounterPerCaller.fixupPrototype(val);
            }
        }
        if (this.heap_analysis) {
            for (let val of this.heap_analysis) {
                models.BackgroundJobHeapAnalysis.fixupPrototype(val);
            }
        }
        if (this.query_counters) {
            for (let key in this.query_counters) {
                let val = this.query_counters[key];
                if (val) {
                    models.BackgroundJobQueryCounters.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Number of jobs currently executing
     */
    executing_jobs: number;

    /**
     * Number of jobs processed
     */
    processed_jobs: number;

    /**
     * Number of jobs restarted
     */
    restarted_jobs: number;

    /**
     * Number of jobs that failed
     */
    failed_jobs: number;

    /**
     * Map from context to number of invalidations
     */
    invalidations: { [key: string]: number; };

    /**
     * Map from context to counter details
     */
    query_counters: { [key: string]: models.BackgroundJobQueryCounters; };

    /**
     * Query counters by callers for selected context
     */
    query_counters_per_caller: Array<models.BackgroundJobQueryCounterPerCaller>;

    /**
     * If true, heap processing is ongoing
     */
    heap_analysis_pending: boolean;

    /**
     * Historical heap analysis
     */
    heap_analysis: Array<models.BackgroundJobHeapAnalysis>;

}
